import { render, staticRenderFns } from "./TaxDetailsPopup.vue?vue&type=template&id=089f3078"
import script from "./TaxDetailsPopup.vue?vue&type=script&lang=js"
export * from "./TaxDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports